module.exports = __webpack_public_path__ + "img/image_group.32537335.png";